import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { DIMENSIONS_DEFAULT_VALUES } from 'pages/common/consts/dimensions-default-values';
import { TFilteredFrontendConfigurationItems } from 'entries/common/widgets/context';
import { Inputs } from '../types';

export const getDefaultValues = ({
  hasDoors,
  hasThickness,
  dimensionState,
  frontendConfigurationInputs,
}: {
  hasDoors: boolean;
  hasThickness: boolean;
  dimensionState: Partial<Inputs>;
  frontendConfigurationInputs: TFilteredFrontendConfigurationItems | null;
}) => ({
  ...(hasDoors && { doors: DIMENSIONS_DEFAULT_VALUES.DOORS_COUNT }),
  ...(hasThickness && { thickness: LayingType.horizontal }),
  ...{
    width: DIMENSIONS_DEFAULT_VALUES.WIDTH,
    length: DIMENSIONS_DEFAULT_VALUES.LENGTH,
    layerThickness: DIMENSIONS_DEFAULT_VALUES.LAYER_THICKNESS,
    area: DIMENSIONS_DEFAULT_VALUES.AREA,
    height: DIMENSIONS_DEFAULT_VALUES.HEIGHT,
  },
  ...(frontendConfigurationInputs
    ? Object.fromEntries(
        Object.values(frontendConfigurationInputs)
          .flat()
          .map(({ name, defaultValue }) => [name, defaultValue ? String(defaultValue) : ''])
      )
    : {}),
  ...dimensionState,
});
